<template>
    <div class="container-fluid px-0 not_found_container">
        <h3>Oops! It seems like this page has disappeared.</h3>
        <p>But no worries, we have many more pages and medication reviews to be explored.</p>
        <RouterLink to="/">Go back to the Explore Meds homepage</RouterLink>
    </div>
</template>

<style scoped>
.not_found_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 76px);
}

</style>
